import React from 'react';
import axios from 'axios';
import { Table, Space, Button, Popconfirm, Tooltip, notification } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
// import Edit from './components/Edit';
import FormM from './Form';
import Spinner from '../../components/spinner';
import * as filter from '../../global/FilterFun';
import AdminHeader from '../../components/adminHeader';
// import Pages from '../../components/pagination';

class competitionList extends React.Component{
    state = { records: [], racecourseList: [], trackList: [], visible: false, rowToEdit: [], loading: false, regCount: 0,
    showNew: false, regionList: []}

    componentDidMount(){      
      this.paginate(1);
      axios.get('/api/racecourse/combo/list/').then(
          res => {
            this.setState({racecourseList: res.data})
          }
      );

      axios.get('/api/track/').then(
          res => {
            this.setState({trackList: res.data})
          }
      );

      axios.get(`/api/racecourse/region/list/`).then(
          res => {
              this.setState({regionList: res.data, loading:false})
          }
      );
    }

    paginate = page =>{
      this.setState({loading: true})
      axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: "Token "+localStorage.getItem('token')
      }
      axios.get(`/api/competition/?page=${page}`).then(
          res => {
              this.setState({records: res.data, loading:false, regCount: res.data.count})
          }
      )
    }

    getColumnSearchProps = dataIndex => filter.getColumnSearchProps(dataIndex)     
    
    showModal = id => {
      this.setState({loading: true});
      axios.get(`/api/competition/${id}/`).then(
          res => {
              this.setState({rowToEdit: res.data, visible: true, loading: false})
          }
      );
    };

    delete = id => {
      this.setState({loading: true});
      axios.delete(`/api/competition/${id}/`).then(
          res => {
            notification["success"]({
              message: 'Registro eliminado exitosamente',
            });
            this.setState({loading: false});
            this.paginate(1);
          }
      );
    };
  
    showNew = b => {
      this.setState({
        showNew: b,
      });
    };

    regSaved = s =>{
      this.showNew(false)
      if(s === true){
        this.paginate(1);
      }
    }
  
    handleCancel = e => {
      this.setState({
        visible: false,
      });
      if(e === true){
        this.paginate(1);
      }
    };

    render(){
        const racecourseFilter = this.state.racecourseList.map(function (data, idx) {
          return {'text' : data.name, 'value' : data.name, 'Key' : idx}
        });

        const trackFilter = this.state.trackList.map(function (data, idx) {
          return {'text' : data.name, 'value' : data.name, 'key' : idx}
        });

        const regionFilter = this.state.regionList.map(function (data, idx) {
          return {'text' : data.name, 'value' : data.id, 'key' : idx}
        });

        const columns = [
            {
              title: 'Región',
              render: (record) => record.region.name,
              filters: regionFilter,
              filterMultiple: false,
              onFilter: (value, record) => record.region.name.indexOf(value) === 0,
              sortDirections: ['descend', 'ascend'],
            },
            {
              title: 'Nombre',
              dataIndex: 'name',
              ...this.getColumnSearchProps('name'),
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections: ['ascend', 'descend'],
            },
            {
              title: 'Hipódromo',
              // dataIndex: 'racecourse',
              render: (record) => record.racecourse.name,
              filters: racecourseFilter,
              filterMultiple: false,
              onFilter: (value, record) => record.racecourse.name.indexOf(value) === 0,
              sortDirections: ['descend', 'ascend'],
            },
            {
              title: 'Pista',
              dataIndex: 'track',
              filters: trackFilter,
              filterMultiple: false,
              onFilter: (value, record) => record.track.indexOf(value) === 0,
              sortDirections: ['descend', 'ascend'],
            },
            {
              title: 'Grado',
              dataIndex: 'grade',
              ...this.getColumnSearchProps('grade'),
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections: ['ascend', 'descend'],
            },
            {
              title: 'Distancia',
              dataIndex: 'distance',
              ...this.getColumnSearchProps('distance'),
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections: ['ascend', 'descend'],
            },
            {
                title: 'Acciones',
                key: 'action',
                width: '20%',
                render: (text, record) => (
                  <Space size="middle">
                    <Tooltip title="Editar">
                      <Button type="primary" onClick={() => this.showModal(record.id)}>
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                    <Popconfirm title="Eliminará un registro, ¿continuar?"
                      onConfirm={() => this.delete(record.id)}
                      onCancel={this.cancel}
                      okText="Si"
                      cancelText="No"
                    >
                      <Tooltip title="Eliminar">
                        <Button type="primary" danger>
                          <DeleteOutlined />
                        </Button>
                      </Tooltip>
                    </Popconfirm>
                  </Space>
                ),
            },
          ];
        return(
            <div>
                { localStorage.getItem('token') == null ? this.props.history.push('/login') : ''}
                <AdminHeader title="Competiciones" showNew={this.showNew} />
                <Spinner spinning={this.state.loading}>
                  <Table columns={columns} dataSource={this.state.records} pagination={{pageSize: 20}} />
                  {/* <Pages paginate={this.paginate} regCount={this.state.regCount} /> */}

                  <FormM visible={this.state.visible} onCancel={this.handleCancel}
                    data={this.state.rowToEdit} trackList={this.state.trackList} racecourseList={this.state.racecourseList}
                    regionList={this.state.regionList} />

                  <FormM visible={this.state.showNew}  onCancel={this.regSaved}
                    trackList={this.state.trackList} racecourseList={this.state.racecourseList} regionList={this.state.regionList} />
                </Spinner>
            </div>
        );
    }
}

export default competitionList;